module.exports = __webpack_public_path__ + "img/006-woman-1.1c143a74.svg";